import type { ErrorResponse } from '@/types/apiTypes';

export const prefixErrorFields = (error: ErrorResponse<unknown>, prefix?: string): ErrorResponse<unknown> => {
  if (!prefix || !error?.errors) {
    return error;
  }

  const prefixedErrors: Record<string, unknown> = {};

  Object.entries(error.errors).forEach(([key, value]) => {
    prefixedErrors[key === 'details' ? key : `${prefix}.${key}`] = value;
  });

  return { ...error, errors: prefixedErrors };
};
